module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/MN2zhF/tc-custom/9781418585884.jpg?1708485485778",
      "alt": "This image is the cover for the book Beautiful Mess"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Beautiful Mess\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("Can a band comprised of six very talented but very different musicians make a difference with their music?")])]), _c('p', [_vm._v("What made it possible for Diamond Rio to weather the storms inherent in the fickle world of fame and fortune and go more than two decades without a single lineup change? Any reader in search of transparency and a behind-the-scenes look into the life of the band as a unit as well as the individual lives of the players and singers will be well satisfied. Can true loyalty exist within the competitive, seemingly unforgiving music industry? In "), _c('i', [_vm._v("Beautiful Mess ")]), _vm._v("Marty Roe, Dan Truman, Jimmy Olander, Brian Prout, Gene Johnson, and Dana Williams each has an entire chapter devoted to his personal and professional life. The book’s tone is a welcome rarity—not written from one player’s perspective, but from all six as they “meet in the middle.” "), _c('i', [_vm._v("Beautiful Mess ")]), _vm._v("is a wild ride from the edge of disaster and a little-known secret to an ongoing heart-warming revival.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Diamond Rio\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Thomas Nelson\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0